export default __webpack_public_path__ + "static/media/ecommerce.becad999.png";